import { Activity, AlertTriangle, CheckCheck, Layers3 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const SUMMARY_ITEMS = [
  { key: 'total', label: 'Actividades', accent: 'text-slate-900', icon: Layers3, chip: 'Volume' },
  { key: 'completion_rate', label: 'Cumprimento', accent: 'text-emerald-700', suffix: '%', icon: CheckCheck, chip: 'Performance' },
  { key: 'backlog', label: 'Pendências', accent: 'text-amber-700', icon: AlertTriangle, chip: 'Risco' },
  { key: 'backlog_index', label: 'Índice backlog', accent: 'text-rose-700', icon: Activity, chip: 'Pressão' },
];

export const OperationalSummaryCards = ({ summary = {}, testIdPrefix = 'operational-summary' }) => (
  <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-4" data-testid={`${testIdPrefix}-grid`}>
    {SUMMARY_ITEMS.map((item) => (
      <Card key={item.key} className="h-full rounded-lg border border-slate-200 bg-white shadow-sm" data-testid={`${testIdPrefix}-${item.key}-card`}>
        <CardHeader className="flex flex-row items-start justify-between space-y-0 px-3 pb-1 pt-3">
          <div className="space-y-1">
            <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500" data-testid={`${testIdPrefix}-${item.key}-chip`}>
              {item.chip}
            </span>
            <CardTitle className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500">{item.label}</CardTitle>
          </div>
          <div className="rounded-md border border-slate-200 bg-slate-50 p-1.5 text-slate-600" data-testid={`${testIdPrefix}-${item.key}-icon`}>
            <item.icon className="h-3.5 w-3.5" />
          </div>
        </CardHeader>
        <CardContent className="px-3 pb-3 pt-0">
          <p className={`text-[24px] font-semibold leading-none tracking-tight ${item.accent}`} data-testid={`${testIdPrefix}-${item.key}-value`}>
            {summary?.[item.key] ?? 0}{item.suffix || ''}
          </p>
          <p className="mt-1 text-[10px] text-slate-500" data-testid={`${testIdPrefix}-${item.key}-subtext`}>
            Visão operacional actual do período seleccionado.
          </p>
        </CardContent>
      </Card>
    ))}
  </div>
);